import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { inviteLandlordAction } from 'store/actions/inviteActions';
import { failedNotif } from 'store/actions/notifActions';
import { buildLandlordInvitePayload } from 'utils/buildLandlordInvitePayload';
import { ComposeEmailForm } from './ComposeEmailForm';

const DEFAULT_SUBJECT = "You've been Invited to the Leap Portal";
const DEFAULT_CONTENT = 'You have been invited to the Leap Portal.';

export const EmailEditor = ({
  setOpen,
  onClose,
  toEmail,
  landlordId,
  loading = false,
  onInviteStart,
}) => {
  const dispatch = useDispatch();
  const [toEmailValue, setToEmailValue] = useState('');
  const [subject, setSubject] = useState(DEFAULT_SUBJECT);
  const currentUserState = useSelector((state) => state.getIn(['auth', 'currentUser']));
  const currentUser = currentUserState ? currentUserState.toJS() : null;
  const fromEmail =
    currentUser?.email || JSON.parse(localStorage.getItem('user') || '{}')?.email || '';

  useEffect(() => {
    setToEmailValue(Array.isArray(toEmail) ? toEmail.filter(Boolean).join(', ') : '');
    setSubject(DEFAULT_SUBJECT);
  }, [toEmail]);
  const handleSend = (latestContent) => {
    if (!latestContent || latestContent === '<br>') return;
    const built = buildLandlordInvitePayload({
      toEmail: toEmailValue,
      emailSubject: subject || DEFAULT_SUBJECT,
      emailContent: latestContent,
      landlordID: landlordId,
    });
    if (built.error) {
      dispatch(failedNotif(built.error));
      return;
    }
    onInviteStart?.();
    dispatch(inviteLandlordAction(built.payload));
  };

  return (
    <ComposeEmailForm
      fromEmail={fromEmail}
      toEmail={toEmailValue}
      subject={subject}
      initialContent={DEFAULT_CONTENT}
      onToEmailChange={setToEmailValue}
      onSubjectChange={setSubject}
      onClose={() => {
        if (onClose) {
          onClose();
          return;
        }
        setOpen(false);
      }}
      onSend={handleSend}
      sendDisabled={!toEmailValue.trim()}
      loading={loading}
    />
  );
};
